const tm = {
  // loader
  "loading-main": "Biraz garaşyň maglumatlar ýüklenýär...",
  // auth Header
  "online reception": "Sanly bank hyzmatlary",
  Individual: "Fiziki şahs",
  Entity: "Ýurdiki şahs",
  // auth footer
  phone: "telefon",
  Address: "Doly salgysy",
  "All right reserved": "Ähli hukuklar goragly",
  slogan: "Geljegiňizi biz bilen dörediň!",
  address_of_the_bank: "Aşgabat ş.Magtymguly şaýoly 111/2",
  // Login page
  "Sign in": "Ulgama girmek",
  "Sign up": "Agza bolmak",
  "Forgot password": "Açar söz ýatdan çykdymy",
  Enter: "Girmek",
  Username: "Ulanyjynyň ady",
  Password: "Gizlin açar sözi",
  "Invalid grand": "Ulanyjynyň ady ýa-da gizlin açar sözi nädogry",
  // register page
  "success registered": "Üstünlikli hasaba alyndyňyz",
  "user has already registered": "Bu ulanyjy eýýäm hasaba alnan",
  "email has already registered": "Bu elektron poçta eýýäm hasaba alnan",
  "Is not same passwords": "Açarlar deň gelenok",
  "Minimum 8 symbol": "Azyndan 8 simwol",
  Name: "Ady",
  Surname: "Familiýasy",
  "Phone number": "Telefon belgisi",
  Email: "Email",
  "Input email correctly": "Email-i dogry giriziň",
  "User data": "Ulanyjynyň maglumatlary",
  "Private data": "Şahsy maglumatlar",
  "Password confirm": "Gizlin açar sözi gaýtalaň",
  Required: "Bu hökmany",
  Back: "Yza",
  "register disabled":
    "Ýuridiki taraplar bu hyzmaty birikdirmek üçin banka ýüz tutyp bilerler",
  // request status
  "Successfully sent": "Üstünlikli ugradyldy",
  "filled inputs": "Doldurlan maglumatlar",
  // room header
  "Call-center": "Sorag-jogap",
  Profile: "Profaýl",
  "Change password": "Gizlin açary çalyşmak",
  Logout: "Çykmak",
  "Are you sure to exit": "Siz çykmakçymy?",

  // room
  Welcome: "Hoş geldiňiz",
  // maintable
  Type: "Görnüşi",
  Date: "Döredilen senesi",
  inviteDate: "Gelmeli senesi",
  noInviteDate: "Bellenmedik",
  Status: "Ýagdaýy",
  Action: "Amal",
  "Per page": "Her sahypada",
  Rejected: "Red edildi",
  Done: "Taýyn",
  Success: "Kabul edildi",
  Pending: "Garaşylýar",
  Corrected: "Düzedildi",
  paymentPending: "Tölege garaşylýar",
  correctionRequired: "Düzediş girizmeli",
  // ViewItem
  Info: "Maglumat",
  Notes: "Bellikler",
  "type of document": "Güwanamanyň görnüşi",
  "type of card": "Kartyň görnüşi",
  "type of credit": "Karzyň bölümi",
  "By who": "Kim tarapyndan",
  "Is hurry": "Gyssaglymy",
  "With delivery": "Eltip berme hyzmatyndan peydalanan",
  Yes: "Hawa",
  No: "Ýok",
  "Max credit amount": "Karz möçberi",
  "Credit amount": "Karz möçberi",
  "Credit percentage": "Karz göterimi",
  "Credit term": "Karzyň möhleti",
  "Credit repayment base": "Karzy gaýtarmagyň üpjünçiligi",
  "credit repayment sources": "Karzy üzmegiň çeşmeleri",
  "credit repayment ways": "Karzy üzmegiň çeşmeleri",
  month: "aý",
  "No note": "Bellik ýok",
  invitationDate: "Gelmeli senesi/wagty",
  invitationNote: "Gelmeli senesi/wagty boýunça bellik",
  correctionNote: "Düzediş boýunça bellik",
  //steps
  "Select type of card": "Kartyň görnüşini saýlaň",
  "Input private data": "Şahsy maglumatlar",
  "Card data": "Kart almak üçin maglumatlar",
  "Extra data": "Goşmaça maglumatlar",
  "Select payment type": "Tölegiň görnüşini saýlaň",
  // private date
  "Input name correctly": "Adyňyzy dogry giriziň",
  "Input surname correctly": "Familiýaňyzy dogry giriziň",
  "Input thirdname correctly": "Ataňyzyň adyny dogry giriziň",
  "Input birthdate correctly": "Doglan senäňizi dogry giriziň",
  //
  Thirdname: "Atasynyň ady",
  Birthdate: "Doglan senesi",
  "Passport serie": "Pasport belgisi",
  "Passport given date": "Pasportyň berlen senesi",
  "Passport given place": "Pasportyň berlen ýeri",
  Gender: "Jynsy",
  Male: "Erkek",
  Female: "Aýal",
  male: "Erkek",
  female: "Aýal",
  Turkmen: "Türkmen",
  Other: "Başga",
  Nationality: "Milleti",
  "0": "Ýok",
  "1": "Hawa",
  false: "Ýok",
  true: "Hawa",
  turkmen: "Türkmen",
  /////////////////////////////çard info
  "Name latin": "Ady (latyn harplary bilen)",
  "Surname latin": "Familiýasy (latyn harplary bilen)",
  "Input latin": "Diňe latyn harplary bilen",
  "sms connection": "Sms birikdirme hyzmaty",
  "Home phone": "Öý telefony",
  "Birth place": "Doglan ýeri",
  "Code word to define":
    "Bank bilen habarlaşanyňyzda siziň anyklanmagyňyz üçin kod sözi",
  "Secret word": "Gizlin söz",
  Note: "Bellik",
  "Select branch": "Baş bank ýa-da bankyň şahamçasyny saýlaň",
  Services: "Goşmaça hyzmatlar",
  ourServices: "Hyzmatlarymyz",
  deliveryService: "Eltip berme hyzmaty",
  hurryService: "Gyssagly hyzmaty",
  Next: "Öňe",
  close: "Ýapmak",
  "Card payment": "Kartyň tölegi",
  "Summary payment": "Umumy töleg",
  "Confirm the data": "Maglumatlary tassyklamak",
  Branch: "Baş bank ýa-da bankyň şahamçasy",
  "I confirm": "Tassyklaýaryn",
  Correct: "Düzetmek",
  ////////////new Credit request
  "Credit data": "Karz almak üçin maglumatlar",
  "Credit calculator": "Karz hasaplaýjy",
  "Select type of credit": "Karzyň görnüşini saýlaň",
  "year-a": "ýyl",
  year: "ýyl",
  years: "ýyl",
  monthes: "aý",
  "month-a": "aý",
  thousand: "müň",
  "monthly payment": "Aýdaky töleg",
  "Percentage payment": "Göterim üçin töleg",
  "Credit payment": "Karzyň esasy bergisiniň töleg möçberi",
  "Need salary for credit": "Azyndan karz alyjynyň girdeji möçberi",
  "Credit requirement": "Karzyň üpjünçiligi",
  "credit calc notice 1":
    "Karzyň möhletine görä her aýdaky tölegiň möçberi kesgitlenýär",
  "credit calc notice 2":
    "1 ýylda 365 gün we ortaça 1 aýda 30 gün hasaby bilen",
  "Salary or family income":
    "Aýlyk zähmet hakynyň ýa-da maşgala girdejisiniň möçberi",
  "Can input salary or family income":
    "Aýlyk zähmet haky ýa-da maşgala girdejisi girizilip bilner",
  "Work position": "Wezipesi",
  "Work experience": "Soňky iş ýeri boýunça tejribesi",
  "Work place": "Iş ýeri",
  ///////////////request result/////////////
  "Success requested": "Siziň ýüztutmaňyz kabul edildi",
  "Some error, try it again": "Käbir ýalňyşlyk täzeden synanyşyp görüň",
  "Notice you about website":
    '"TTBK" paýdarlar täjirçilik bankynyň internet sahypasynda resminamalaryň sanawy ýerleşdirilendigini Siziň dykgatyňyza ýetirýäris. Sahypa geçmek üçin',
  "follow the link": "şu ýere basyň",
  "Responsible staff": "Size jogapkär işgär",
  "Necessary docs": "Gerekli resminamalar",
  successDialogNotice:
    "Bank hünärmenleri tarapyndan arzaňyz öwrenilip, onuň ýagdaýy barada Size SMS habar beriler.",
  "Bank address": "Bankyň salgysy",
  "Room location": "Siziň barmaly otagyňyz",
  Floor: "Gat",
  Room: "Otag",
  /////////////////new document request
  "Online service payment": "Onlaýn hyzmaty",
  "Is bussinessman": "Telekeçimi",
  "Select type of document": "Güwanamanyň görnüşini saýlaň",
  "Document data": "Güwanama üçin maglumatlar",

  //////////////////EmptyData.js
  "Yuzlenme yok": "Ýüzlenme ýok",
  ////////////////////HomePhone.js
  "Input home phone correctly": "Öý telefon belgiňizi dogry giriziň",
  ///////////////////////Nationality.js
  "Input nationality correctly": "Milletiňizi dogry giriziň",
  ///////////////////////////PassportGiýenDate.js
  "Проверьте правильность даты выдачи": "Berlen senäniň dogrulygyny barlaň",
  "Дата выдачи не может быть в будущем": "Berlen sene öňümizde",
  ///////////////////////PassportGivenPlace
  "Input passport given place correctly":
    "Passportyň berlen ýerini dogry giriziň",
  ////////////////////////////Passport number
  "Input passport serie correctly": "Passport belgisini dogry giriziň",
  //////////////////////////////EmailÝerify.js
  "Açary çalyşmak üçin ssylka email-e ugradyldy":
    "Açary çalyşmak üçin ssylka email-e ugradyldy",
  "Email-i dogry giriziň": "Email-i dogry giriziň",
  "Açary dikeltmek": "Açary dikeltmek",
  "Email dogry girizin": "Email dogry girizin",
  Ýapmak: "Ýapmak",
  Ugratmak: "Ugratmak",
  ///////////////////////Foooter.js
  "Geljegiňizi biz bilen dörediň!": "Geljegiňizi biz bilen dörediň!",
  ///////////////////CardInfoCheck.js
  Informations: "Maglumatlar",
  "Töleg maglumatlary": "Töleg maglumatlary",
  "Agree to payment policy": "Tölegiň düzgün-kadalary bilen ylalaşýaryn",
  ///////////////////////CardSelect.js
  "Hasaplaşyk walýutasy": "Hasaplaşyk walýutasy",
  ////////////////CreditCalc.js
  "Karzyň möhletine görä her aýdaky tölegiň möçberi kesgitlenýär":
    "Karzyň möhletine görä her aýdaky tölegiň möçberi kesgitlenýär",
  "1 ýylda 365 gün we ortaça 1 aýda 30 gün hasaby bilen":
    "1 ýylda 365 gün we ortaça 1 aýda 30 gün hasaby bilen",
  /////////////////////CreditInfoCheck.js
  "Karz maglumatlary": "Karz maglumatlary",
  "Agree to private policy": "Hususylyk syýasaty bilen ylalaşýaryn",
  //////////////////////CreditInfoSection.js
  "Not enough salary or family income":
    "Ýeterlik aýlyk zähmet haky ýa-da maşgala girdejisi ýok",
  "Not enough experience": "Ýeterlik tejribe ýok",
  ///////////////////////////////////Header
  "Home page": "Baş sahypa",
  //////////////////////////////Sidebar
  "Card section": "Kart ýüzlenmesi",
  "Document section": "Güwanama ýüzlenmesi",
  "Feedback section": "Arz-şikaýat bölümi",
  profile: "Maglumatlarym",
  "Credit section": "Karz ýüzlenmesi",
  /////////////////////////Restore.jsx
  "Açar üstünlikli dikeldildi": "Açar üstünlikli dikeldildi",
  "Näsazlyk, dikeltme wagty tamamlandy": "Näsazlyk, dikeltme wagty tamamlandy",
  "Email-i dogry girizin": "Email-i dogry girizin",
  "Näsazlyk, täzeden barlap görüň": "Näsazlyk, täzeden barlap görüň",
  "Gizlin açar söz gaýtalap": "Gizlin açar söz gaýtalap ýazyň",
  "Açarlar deň gelenok": "Açarlar deň gelenok",
  Dikeltmek: "Dikeltmek",
  ///////////////////////////////////pages/Room/Card
  "Kart almak üçin onlaýn ýüzlenme": "Kart almak üçin onlaýn ýüzlenme",
  "Ýüzlenme ugratmak": "Ýüzlenme ugratmak",
  ////////////////////////pages/Room/Credit
  "Karz almak üçin onlaýn ýüzlenme": "Karz almak üçin onlaýn ýüzlenme",
  //////////////////////////////////////////pages/Room/Document.jsx
  "Güwanama üçin onlaýn ýüzlenme": "Güwanama üçin onlaýn ýüzlenme",
  ////////////////////////////////pages/Room/Profile/Offers
  "Offered cards": "Berilen  kartlar",
  "Offered credits": "Berilen  karzlar",
  "Offered documents": "Berilen  güwanamalar",

  //////////////////////////////pages/Room/passwordChange
  "old password": "Öňki gizlin açar",
  "new password": "Täze gizlin açar",
  "new password confirm": "Täze gizlin açar gaýtalap",
  Change: "Üýtgetmek",
  "easy code": "Ýeňil açar",
  "middle code": "Ortaça açar",
  "hard code": "Kyn açar",
  "input data is incorrect": "Maglumatlar nädogry girizildi",
  "password successfully changed": "Gizlin açar üstünlikli üýtgedildi",
  "some advices for password": "Käbir maslahatlar",
  "at least one uppercase": "Azyndan 1 sany bas harp bolmaly (A-Z)",
  "at least one number": "Azyndan 1 sany sifr bolmaly (0-9)",
  "at least eight charecter": "Azyndan 8 simwoldan ybarat bolmaly",

  ////////////////////////////pages/Room/feedback
  "Feedback type": "Arzyň görnüşi",
  complain: "Şikaýat",
  recommend: "Teklip",
  "Your text": "Siziň ýazgyňyz",

  ////////////////////////////pages/Room/feedback
  "Select department": "Bölümi saýlaň",
  "Meeting purpose": "Duşuşygyň temasy",
  "Select your free date": "Banka gelip biljek senäniňizi saýlaň",
  "Meet time": "Bellenen sene",
  /////////////////////////////////////////
  "New request": "Täze ýüzlenme",
  "Profile Edit": "Üýtgetmek",
  MiddleName: "Atasyn Ady",
  ChooseRegion: "Bank şahamçasyny saýlaň",
  "Edit Profile": "Profili Üýtgetmek",

  "Add MoreInfo": "Goşmaça maglumat goşuň",
  "Save MoreInfo": "Has giňişleýin maglumat tapyň",
  "Save Changes": "Üýtgetmeleri ýatda sakla",
  "Message from organization": "Guramanyň ýazmaça haýyşy",
  mary: "Mary",
  balkan: "Balkan",
  dasoguz: "Dashoguz",
  ashgabat: "Ashgabat",
  lebap: "Lebap",
  "Online Payment": "Töleg maglumatlary",
  "Total Amount": "Jemi",
  Passport: "Passport",
  "Birth date": "Doglan güni",
  PrivateAutoFill:
    "Maglumatlaryňyz awtomatiki usulda doldurylýar, ýöne üýtgedip bilersiňiz",
  ImageChangeHelpText:
    "Bank bilen habarlaşýan hatyňyzy skanerlemek üçin '+' basyň",
  ScanAreaMove: "Skaneri şu ýere geçiriň",
  supportScanType: "Goldanýan format",
  writeYourMessage: "Habaryňyzy giriziň",
  originNumber: "Çykýan belgisi",
  scanDate: "Select application date",
  notEntered: "Görkezilmedi",
  dataSuccesChanged: "Profil maglumalary üstünlikli üýtgedildi",
  dataSuccesSaved: "Profil maglumatlaryňyz üstünlikli ýatda saklandy",
  Error: "Roralňyşlyk",
  PleaseFillYourProfileData:
    "Profiliňiz barada goşmaça maglumatlary doldurmagyňyzy haýyş edýäris",
  Fill: "Doldur",
  noNotifications: "Sizde entek bildiriş ýok",
  uploadMaxSizeError:
    "Roralňyşlyk. Faýlyň ölçegi 2 megabaýtdan geçdi. Agramy 2 megabaýtdan az bolan faýly saýlaň",
  fileErrorTryAgain: "Ошибка. При попытке удалить файл",
  attention: "Üns beriň",
  descriptionFillProfile:
    "Şahsy hasabyňyza dürli amallar üçin awtomatiki usulda doldurmak üçin profil maglumatlaryňyzy doldurmagyňyzy maslahat berýäris. Bu habary äsgermezlik edip, 'Dowam et' düwmesine basyp bilersiňiz, şonda meýdanlary awtomatiki doldurmazdan el bilen dolduryp bilersiňiz.",
  fillOutData: "Maglumatlary doldurmak",
  continue: "Dowam et",
  loading: "Ýüklemek",
  faceType5: "Fiziki şahs",
  faceType1: "Ýurdiki şahs",
  check: "Barlaň",
  sentAgain: "Has köp iber",
  WeSentOnYourEmailMessage: "E-poçtaňyza iberdik",
  MessageForEdentify: "habar, dowam etmek üçin şahsyýetiňizi tassyklaň",
  YourEmailIsNotFerfied: "E-poçtaňyz tassyklanmady!",
  anotherEmailMessageSented: "Gaýtadan poçta ugradyldy",
  emailSentVerifyError: "Habar ugradylanda näsazlyk ýüze çykdy",
  noVerifiedEmail: "E-poçta tassyklamasy talap edilýär",
  verifiedEmail: "E-poçta tassyklandy",
  GivenDateCantBeAFuture: "Berlen senesi geljekde bolup bilmez",
  Add: "Goş",
  youEmailSuccesVerified: "E-poçtaňyz üstünlikli tassyklandy",
  errorVerifyEmail: "E-poçta tassyklanmadyk",
  succesVerifyEmail: "E-poçtaňyzy barlaň",
  ForeignStudent: "Daşary ýurt talyp tölegi barada",
  PaymentForeignStudent: "Halkara tölegiň ýüzlenmesi",
  PaymentForeignStudentTitle: "Halkara töleg üçin onlaýn ýüzlenmesi",
  selectPaymentType: "Tölegiň görnüşini saýlaň",
  comingSoon: "Išlenilÿär",
  "otp-send-to-your-phone": "OTP telefonyňyza iberildi",
  "login-success": "Ulgama üstünlikli girildi",
  receiverInfo: "Alyjy barada maglumat",
  senderInfo: "Ugradyjy barada maglumat",
  Patronymic: "Atasynyň ady",
  "Surname Before Changed": "Öňki familiýasy",
  "Passport Serial": "Pasport seriýasy",
  "Passport Number": "Pasport belgisi",
  "Passport Given Date": "Pasport berlen senesi",
  "Passport Given Place": "Pasport berlen ýeri",
  Phone: "Telefon belgisi",
  "Birth Place": "Doglan ýeri",
  "Village / City / etc.": "Oba / Şäher / ş.m.",
  "House / Flat Number": "Jaý / Öý belgisi",
  "Select receiver": "Alyjyny saýlaň",
  currency: "Walýuta",
  "Uploading...": "Ýüklenýär...",
  Receiver: "Alyjy",
  "Change info": "Maglumatlary üýtget",
  "No receivers available": "Alyjylar ýok",
  "Add new receiver": "Täze alyjy goşmak",
  "Create new receiver": "Täze alyjy döretmek",
  "Edit receiver": "Alyjyny üýtgetmek",
  "Receiver successfully created": "Alyjy üstünlikli döredildi",
  "Failed to create receiver": "Alyjyny döretmekde näsazlyk çykdy",
  "Receiver successfully updated": "Alyjynyň maglumatlary täzelendi",
  "Failed to update receiver": "Alyjynyň maglumatlaryny täzeläp bolmady",
  "Only letters allowed": "Diňe harplar rugsat berilýär",
  "Minimum 3 characters": "Iň azyndan 3 harp",
  "Maximum 50 characters": "Iň köp 50 harp",
  livingAddress: "Häzirki ýaşaýan salgysy",
  formalAddress: "Hasaba duran salgysy",
  workUniver: "Uniwersitetiň doly ady",
  Country: "Ýurt",
  "Select country": "Alyjynyň ýerleşýän ýurdy",
  "Birth Date": "Doglan senesi",
  "Format: I-AB or II-CD": "Format: I-AŞ ýa-da II-DZ",
  "Must be exactly 6 digits": "Takyk 6 sany san bolmaly",
  "Phone format must start with + and contain only digits":
    "Telefon belgisi + bilen başlamaly we diňe sanlardan ybarat bolmaly",
  "Only letters, numbers, commas, slashes, and hyphens allowed":
    "Diňe harplar, sanlar, oturlar, drob we defis rugsat berilýär",
  // Gender: "Jynsy",
  // Male: "Erkek",
  // Female: "Aýal",
  // Nationality: "Milleti",
  Citizenship: "Raýatlygy",
  "Select citizenship": "Raýatlygy saýlaň",
  Cancel: "Goýbolsun",
  "Save Receiver": "Alyjyny ýazdyr",
  // "Save Changes": "Üýtgetmeleri ýazdyr",
  or: "ýa-da",
  onlyTurkmenistanCitizens:
    "Häzirki wagtda diňe Türkmenistanyň raýatlary üçin mümkinçilik bar",
  "type of payment": "Töleg görnüşi",
  Amount: "Mukdary",
  "Visa status": "Wiza statusy",
  "Select visa status": "Wiza statusyny saýlaň",
  VisaStudent: "Talyp",
  VisaTourist: "Syýahatçy",
  VisaWork: "Iş",
  Documents: "Resminamalar",
  "Payer documents": "Ugradyjyň resminamalary",
  "Payee documents": "Alyjyň resminamalary",
  senderDocs:
    "Ugradyjyň resminamalary - pasportlar (ýerli, daşary ýurt), zähmet depderçesi, pensiýa şahadatnamasy, iş ýerinden kepilnama",
  receiverDocs:
    "Alyjyň resminamalary - okuw ýerinden kepilnama (talyp bolsa), bank rekvizitleri, pasportlar (ýerli, daşary ýurt), garyndaşlygy tassyklaýan resminamalar, ýaşaýyş ygtyýarnamasy)",
  "File size must be under 2MB": "Faýlyň ölçegi 2MB-dan kiçi bolmaly",
  "Enter valid amount": "Dogry mukdary giriziň",
  "Sender Information": "Ugradyjy maglumatlary",
  "Receiver Information": "Alyjy maglumatlary",
  "Payment Information": "Töleg maglumatlary",
  "Surname before changed": "Öňki familiýasy",
  "City / village": "Şäher / oba",
  "House / flat number": "Jaý / öý belgisi",
  "Private Information": "Şahsy maglumatlar",
  "Passport Information": "Pasport maglumatlary",
  "Work Information": "Iş baradaky maglumatlar",
  Workplace: "Iş ýeri",
  Salary: "Aýlyk",
  "Job title": "Wezipe",
  "Please wait...": "Biraz garaşaýyň",
  "Verify Code": "Kody tassyklamak",
  alerts: {
    interPayment: {
      blockedByBank:
        "Talyp tölegini hyzmatyny peýdalanmak üçin degişli bank operatoryna resminamalaryňyzy barlatmagyňyzy haýyş edýäris. Barlagdan geçeniňizden soň onlaýn ýüzlenme ugratmak mümkin bolar.",
      docInactive:
        "Siziň resminamalaryňy könelendigi sebäpli täzeden barlagdan geçmegiňizi haýyş edýäris.",
      docExpiredOn: "Resminamanyň tamamlanan möhleti {{date}}",
      docExpirationNotSet:
        "Resminamanyň tamamlanan möhleti admin tarapyndan bellenmedik",
    },
  },
  man: "Erkek",
  woman: "Aýal",
  reqDosc: "Resminamalar (asyl nusgalary zerur)",
  reqDocsDesc: "Düşündiriş",
  reqDocsUpload: "Resminalary ýüklemek",
  "Choose Files": "Faýllary saýlaň",
  addMoreFiles: "Has köp resminama goşmak",
  "Replace files": "Resminamany üýtgetmek",
  uploadedFiles: "Ýüklenen resminamalar",
  "Already uploaded files": "Ýüklenen resminamalar",
  "Selected files": "Saýlanan resminamalar",
  "No fields required for this payment type":
    "Bu töleg görnüşi üçin zerur meýdanlar ýok",
  newInterPaymentTitle: "Hormatly müşderiler!",
  newInterPaymentAlert:
    "Eger-de okuw tölegleri we ýaşaýyş jaý harajatlary biziň bankymyz arkaly amala aşyrylsa, talyba ugradylýan her aýdaky serişdeleriň diňe elektron ýüzlenme esasynda amala aşyrylýandygyny Siziň dykkatyňyza ýetirýäris.",
  newInterPaymentAlertCheck: "Tanyşdym",
  requestInfoDialog: {
    linkText: "Ylalaşygyň şertlerini",
    text: {
      beforeLink: "Şu Onlaýn arza-anketanyň",
      afterLinkBeforeAction:
        "tassyklap, onuň bilen doly ylalaşýaryn we gyşarnyksyz berjaý etmäge söz berýärin.",
      afterAction:
        "Şu onlaýn arza-anketada maglumatlar hut meniň özümiň girizendigimi we bu maglumatlarymyň dogrydyga, galp däldigine güwä geçýärin.",
    },
    actions: {
      payment: "degişli tölegleri tölemäge",
      credit: "karz almak üçin resminalary ýygnama",
      document: "güwanamany çap etmäge",
      card: "karty göýbermäge",
    },
    checkbox: {
      payment: "“Daşary ýurt puluny çalyşmagyň tertibi” bilen tanyşdym",
      default: "Ylalaşygyň şertleri bilen tanyşdym",
    },
  },
  additionalDocsInfoAlert:
    "Bank tarapyndan goşmaça resminamalar talap edilip biliner",
  uploadedDataFiles: "Ýüklenen faýllar we maglumatlar",
  uploaded: "Ýüklenen",
  invalidFileType: "Nädogry faýl görnüşi. Rugsat berilen: PDF, JPG, JPEG, PNG",
  tb: "№",
  attachPassport: "Pasportyňyzy goşuň",
  personal_account_number: "Şahsy hasap belgiňiz",
  prevPassportNumber: "Öňki pasport belgisi",
  inputHere: "Girizmek",
  invalidCharacters: "Ýalňyş simwollar: < > \\ ` gadagan",
  fileExpired: "Möhleti geçdi",
  fileExpiredReupload: "Täzeden ýükläň",
  reuseFile: "Öňki faýly ulan",
  expiresAt: "Möhleti",
  interConfirmCheckobox:
    "Şu onlaýn arza-anketada maglumatlar hut meniň özümiň girizendigimi we bu maglumatlarymyň dogrydyga, galp däldigine güwä geçýärin.",
};
export default tm;
